// @i18n-ignore-file
export const LB_USER_ID_HEADER = 'x-lb-user-id'
export const REGION_ID_HEADER = 'x-gctx-request-origin-region-id'
export const REGION_LANG_HEADER = 'x-gctx-request-origin-locale'
export const COUNTRY_HEADER = 'cloudfront-viewer-country'

export const CONTENT_TYPE_HEADER = 'Content-Type'
export const XML_CONTENT_TYPE = 'text/xml'
